import app from '../app.first';

app.CheckIdNumber = class extends app.Component {
    onReady() {
        const $idNumberField = $('#pd_id_number');
        const $idNumberWrapper = $('#pd_id_number_wrapper_for_id_validation');

        // Append modal HTML to the body
        $('body').append(`
            <div id="reactivate-modal" class="modal" style="z-index:1012">
                <div class="modal-content">
                    <p>We have noticed this ID belongs to a deleted account. Please reactivate your account.</p>
                    <button id="reactivate-button" class="button">Reactivate</button>
                </div>
            </div>
        `);

        const $modal = $('#reactivate-modal');
        const $reactivateButton = $modal.find('#reactivate-button');

        $idNumberField.on('change', async (e) => {
            const idNumber = $idNumberField.val();

            if (!idNumber) {
                return;
            }

            try {
                const result = await app.ajax('/ajax/check-id-number', { id_number: idNumber }, 'POST');
                $idNumberWrapper.find('.id-number-error').remove();

                if (result.deleted) {
                    // Show the modal
                    $modal.css('display', 'block');
                    $('body').css('overflow', 'hidden'); // Prevent background scrolling
                }
            } catch (error) {
                console.error('Error checking ID number:', error);
            }
        });

        // Redirect to the reactivation URL when the reactivate button is clicked
        $reactivateButton.on('click', () => {
            window.location.href = '/logout?redirect=reactivate';
        });

        // Remove close button and outside click event listeners
    }
}
